<template>
  <div>
      <full-page  ref="fullpageHome" :options="options" id="fullpage">

        <div id="section000"  class="section">
          <h2>LOADING...</h2>

        </div>




<div id="section50" class="section production">
  <a  href="#bio1" class="prodNav">Back to Top</a>

<div class="prodWrap">
          <b-container class="h-100">
            <b-row class="h-100 justify-content-center">
              <b-col><h1>Production Bios</h1></b-col>
            </b-row>
            <b-row class="h-100  justify-content-center">
              <b-col lg="11" xl="12">
                <b-card-group deck >
                  
                  <b-card class="text-center" >
                      <a class="prodLink"  href="#bio2" >
                        <p class="card-title">JESSE ALEXANDER</p>
                        <p class="card-links">(EXECUTIVE PRODUCER, SHOWRUNNER, WRITER EP 201)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio3">
                       <p class="card-title">NEIL GAIMAN</p>
                      <p class="card-links">(AUTHOR, EXECUTIVE PRODUCER, WRITER EP 201)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio4">
                       <p class="card-title">CRAIG CEGIELSKI </p>
                      <p class="card-links">(EXECUTIVE PRODUCER)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio5">
                       <p class="card-title">SCOTT HORNBACHER </p>
                      <p class="card-links">(EXECUTIVE PRODUCER)</p>
                      </a>
                  </b-card>

                </b-card-group>
                  <b-card-group deck >

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio6">
                      <p class="card-title">IAN MCSHANE </p>
                      <p class="card-links">(EXECUTIVE PRODUCER)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio7">
                                           <p class="card-title">STEFANIE BERK  </p>
                      <p class="card-links">(EXECUTIVE PRODUCER)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio8">
                                            <p class="card-title">PADRAIC MCKINLEY </p>
                      <p class="card-links">(EXECUTIVE PRODUCER)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio9">
                      <p class="card-title">CHRISTOPHER J. BYRNE </p>
                      <p class="card-links">(EXECUTIVE PRODUCER, DIRECTOR EP 201 and 208)</p>
                      </a>
                  </b-card>

                </b-card-group>
                  <b-card-group deck >
                  
                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio10">
                      <p class="card-title">LISA KUSSNER </p>
                      <p class="card-links">(PRODUCER)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio11">
                      <p class="card-title">HEATHER BELLSON</p>
                      <p class="card-links">(CO-EXECUTIVE PRODUCER, WRITER EP 203 and 207)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio12">
                      <p class="card-title">RODNEY BARNES</p>
                      <p class="card-links">(CO-EXECUTIVE PRODUCER, WRITER EP 205)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio13">
                      <p class="card-title">ADRIA LANG</p>
                      <p class="card-links">(SUPERVISING PRODUCER, WRITER 206)</p>
                      </a>
                  </b-card>

                </b-card-group>
                  <b-card-group deck >
                  
                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio14">
                      <p class="card-title">PETER CALLOWAY</p>
                      <p class="card-links">(CONSULTING PRODUCER, WRITER EP 204)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio15">
                      <p class="card-title">ORLANDO JONES </p>
                      <p class="card-links">(CONSULTING PRODUCER)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio16">
                      <p class="card-title">ANDRES FISCHER-CENTENO</p>
                      <p class="card-links">(CO-EXECUTIVE PRODUCER, WRITER EP 205)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio17">
                      <p class="card-title">ADITI BRENNAN KAPIL</p>
                      <p class="card-links">(WRITER EP 204, 208)</p>
                      </a>
                  </b-card>

                </b-card-group>
                  <b-card-group deck >
                  
                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio18">
                      <p class="card-title">TYLER DINUCCI </p>
                      <p class="card-links">(WRITER EP 202)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio19">
                      <p class="card-title">TICO POULAKAKIS</p>
                      <p class="card-links">(DIRECTOR OF PHOTOGRAPHY)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio20">
                      <p class="card-title">DAVID GREENE</p>
                      <p class="card-links">(DIRECTOR OF PHOTOGRAPHY)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio21">
                      <p class="card-title">MARC LALIBERTÉ ELSE</p>
                      <p class="card-links">(DIRECTOR OF PHOTOGRAPHY EP 208, SECOND UNIT DOP RUN OF SEASON)</p>
                       </a>
                  </b-card>

                </b-card-group>
                  <b-card-group deck >
                  
                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio22">
                      <p class="card-title">RORY CHEYNE </p>
                      <p class="card-links">(PRODUCTION DESIGNER)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio23">
                      <p class="card-title">DEBRA ZANE </p>
                      <p class="card-links">(CASTING DIRECTOR)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio24">
                      <p class="card-title">JASON KNIGHT</p>
                      <p class="card-links">(CASTING DIRECTOR - CANADA)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio25">
                      <p class="card-title">CLAIRE ANDERSON</p>
                      <p class="card-links">(COSTUME DESIGNER EP 201–204)</p>
                       </a>
                  </b-card>

                </b-card-group>
                  <b-card-group deck >
                  
                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio26">
                      <p class="card-title">ROBERT BLACKMAN</p>
                      <p class="card-links">(COSTUME DESIGNER EP 205–208)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio27">
                      <p class="card-title">COLIN PENMAN </p>
                      <p class="card-links">(HEAD OF MAKEUP DEPARTMENT)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                       <a class="prodLink"  href="#bio28">
                      <p class="card-title">DANIEL CURET</p>
                      <p class="card-links">(HEAD OF HAIR DEPARTMENT)</p>
                       </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio29">
                      <p class="card-title">LAYTON MORRISON </p>
                      <p class="card-links">(STUNT COORDINATOR)</p>
                      </a>
                  </b-card>

                </b-card-group>
                  <b-card-group deck >
                  
                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio30">
                      <p class="card-title">ERIC ROBERTSON</p>
                      <p class="card-links">(SENIOR VISUAL EFFECTS SUPERVISOR)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio31">
                      <p class="card-title">FREDERICK E.O. TOYE </p>
                      <p class="card-links">(DIRECTOR EP 202)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio32">
                      <p class="card-title">DEBORAH CHOW </p>
                      <p class="card-links">(DIRECTOR EP 203)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio33">
                      <p class="card-title">STACIE PASSON </p>
                      <p class="card-links">(DIRECTOR EP 204)</p>
                      </a>
                  </b-card>
                </b-card-group>
                  <b-card-group deck >
                  
                  <b-card class="text-center" >
                      <a class="prodLink"  href="#bio34">
                      <p class="card-title">SALLI RICHARDSON-WHITFIELD </p>
                      <p class="card-links">(DIRECTOR EP 205)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                      <a class="prodLink"  href="#bio35">
                      <p class="card-title">RACHEL TALALAY  </p>
                      <p class="card-links">(DIRECTOR EP 206)</p>
                      </a>
                  </b-card>

                  <b-card class="text-center">
                    <a class="prodLink"  href="#bio36">
                      <p class="card-title">PACO CABEZAS  </p>
                      <p class="card-links">(DIRECTOR EP 207)</p>
                    </a>
                  </b-card>

                  <b-card class="text-center" style="border: none; box-shadow: none;">
                     
                  </b-card>

              </b-card-group>

              </b-col>
            </b-row>
          </b-container>

</div>
         <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />

        </div>

          <div id="section51" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        

                            <h2><strong>JESSE ALEXANDER</strong></h2>
                            <h3><strong>(EXECUTIVE PRODUCER, SHOWRUNNER, WRITER EP 201)</strong></h3>
                            <p>Jesse Alexander serves as executive producer, writer and showrunner on Season 2 of Starz&rsquo;s &ldquo;American Gods,&rdquo; based on Neil Gaiman&rsquo;s award-winning novel.</p>
                            <p>He recently served as co-executive producer on the first season of &ldquo;Star Trek: Discovery,&rdquo; garnering him a Hugo nomination for the episode &quot;Magic to Make the Sanest Man Go Mad.&quot; Additional co-executive producer credits include Starz&rsquo;s original series &ldquo;Da Vinci&rsquo;s Demons,&rdquo; and the epic saga series<br>
                            &ldquo;Heroes.&rdquo; Alexander helped develop the pilot of ABC&rsquo;s groundbreaking serial adventure &ldquo;Lost,&rdquo; serving as a co-executive producer through Season 1 and sharing the Emmy<sup>&reg;</sup> Award for Outstanding Drama with his fellow &ldquo;Lost&rdquo; producers.</p>
                            <p>As an executive producer and writer, Alexander&rsquo;s credits include the critically acclaimed series &ldquo;Hannibal&rdquo; and &ldquo;Alias&rdquo; as well as the television movies <em>The Saint </em>and <em>Day One</em>, which he also created.</p>
                            <p>He has also been an innovator in the field of transmedia storytelling — the process of extending narrative across multiple media platforms simultaneously. This strategy was critical to the success of &ldquo;Alias&rdquo; and &ldquo;Lost.&rdquo; The transmedia content he designed for &ldquo;Heroes&rdquo; established a new paradigm for how television shows can thrive cross-platform. In 2008, Alexander shared an Emmy<sup>&reg;</sup> Award for the &ldquo;Heroes&rdquo; online content.</p>
                            <p>An award-winning writer and producer of TV, movies, video games and comic books, Alexander has brought his vision of the cross-platform future of entertainment to MIT, Lucasfilm, NewTeeVee, Game Developers Conference, Microsoft Research, AFI, SMPTE, Ubisoft, USC, BBDO Energy, Netflix, Riot Games, FoxNext, Amazon, and others.</p>
                            <p>In another life, Alexander wrote <em>Eight Legged Freaks</em>, that movie about giant spiders!</p>

                        
                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section52" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>

                            <h2>NEIL GAIMAN</h2>
                            <h3><strong>(AUTHOR, EXECUTIVE PRODUCER, WRITER EP 201)</strong></h3>
                            <p>Neil Gaiman is the New York Times best-selling author of books, short stories, films, and graphic novels for readers of all ages. He is listed as one of the top 10 living post-modern writers by the Dictionary of Literary Biography. His books have been translated into more than thirty languages and have sold close to 7 million copies overseas.</p>
                            <p>Some of his most notable titles include the novels <u>American Gods</u> (for which he received the Hugo, Nebula, Bram Stoker and Locus Awards, and which sold half a million copies in the U.K. alone), <em>The Graveyard Book </em>(the first book to ever win both the Newbery and Carnegie medals), and <em>The Ocean at </em><em>the End of the Lane</em>, which was named the U.K.'s National Book Award 2013 Book of the Year.</p>
                            <p>Gaiman is currently turning <em>Good Omens</em>, the novel he co-wrote with Sir Terry Pratchett, into a six-part television series with the BBC and Amazon. The second season of &ldquo;American Gods&rdquo; is currently in filming and will be released in 2019 on the Starz Network in conjunction with Fremantle and Amazon.</p>
                            <p>Gaiman is also the creator of the hugely popular <em>Sandman </em>comic series, which was the first comic book to ever receive literary recognition when it won the World Fantasy Award – Short Fiction. The latest installment of the series, <em>The Sandman Overture</em>, was named Amazon Best Graphic Novel of 2015.</p>
                            <p>Recently published were his New York Times list topper <em>Norse Mythology</em>, a retelling of the stories of the Norse gods and giants from the Prose and Poetic Eddas; the bestselling non-fiction collection, <em>The View From the Cheap Seats</em>; and the No. 1 best-seller, the reimagined fairy tale <em>The Sleeper and the Spindle </em>(with illustrations by U.K. Children's Laureate, Chris Riddell).</p>
                            <p>Gaiman is Professor in the Arts at Bard College. He has four children, and is married to performer/writer Amanda Palmer.</p>

                        
                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section53" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        

<h2>CRAIG CEGIELSKI</h2>
<h3>(EXECUTIVE PRODUCER)</h3>
<p>In June of 2017, Craig Cegielski founded Centinel Media, an independent television company dedicated to the development, production and global distribution of television programming.</p>
<p>Prior to launching Centinel Media, Cegielski served as the Co-CEO of FremantleMedia North America (FMNA). The veteran television executive led the company into scripted television with the critically acclaimed &ldquo;American Gods&rdquo; as well as the A&amp;E series &ldquo;The Returned.&rdquo;</p>
<p>Previously, Cegielski was president of GK-TV, a division of Graham King&rsquo;s GK Films. While at GK Films, he produced and distributed titles that included &ldquo;Camelot,&rdquo; and the Syfy series &ldquo;Continuum.&rdquo;</p>
<p>As the executive vice president of programming and sales for Lionsgate International Television, Cegielski was responsible for oversight of all international distribution, acquisitions, sales and marketing for the international television group&rsquo;s comprehensive slate of top-rated and critically acclaimed entertainment programming.</p>
<p>Prior to joining Lionsgate, Cegielski worked for CBS/King World International, where he specialized in local production and programming. During his tenure, he successfully launched local adaptations of U.S. and international formats, such as the hit series &ldquo;America&rsquo;s Next Top Model&rdquo; and highly rated game shows such as &ldquo;Wheel of Fortune,&rdquo; &ldquo;Jeopardy!&rdquo; &ldquo;Hollywood Squares&rdquo; and &ldquo;The Vault.&rdquo; He was also responsible for the acquisition of new reality and game shows such as &ldquo;Word for Word.&rdquo;</p>
<p>From 1998 through 2004, Cegielski worked for Paramount Pictures in the co-production division of Paramount International Television. There, his focus was in developing and producing programming for the international marketplace. This emphasis produced an impressive slate that included four one-hour series, including USA Network&rsquo;s hit drama &ldquo;The Dead Zone&rdquo; as well as two miniseries and 10 telefilms.</p>

                        
                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section54" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        

<h2>SCOTT HORNBACHER</h2>
<h3>(EXECUTIVE PRODUCER)</h3>
<p>As executive producer of &ldquo;Mad Men,&rdquo; Scott Hornbacher directed nine episodes: &ldquo;Wee Small Hours,&rdquo; &ldquo;Waldorf Stories,&rdquo; &ldquo;Far Away Places,&rdquo; &ldquo;Dark Shadows,&rdquo; &ldquo;The Doorway (Parts 1 and 2),&rdquo; &ldquo;Time Zones,&rdquo; &ldquo;The Monolith&rdquo; and &ldquo;Severance.&rdquo; He is the recipient of four Emmy<sup>&reg;</sup> Awards, three BAFTA Awards, and three Producers Guild Awards for Best Drama for the series.</p>
<p>Prior to &ldquo;Mad Men,&rdquo; Hornbacher served as co-producer for five seasons of &ldquo;The Sopranos.&rdquo; He is currently executive producer on Season 2 of Neil Gaiman&rsquo;s &ldquo;American Gods&rdquo; for Starz. In his recent role as executive producer on &ldquo;The Last Tycoon&rdquo; for Amazon, he also directed two episodes — &ldquo;Burying the Boy Genius&rdquo; and &ldquo;An Enemy Among Us&rdquo; — starring Matt Bomer, Kelsey Grammer, Lily Collins and Rosemarie DeWitt.</p>
<p>His additional directing credits include an episode of the CBS drama &ldquo;Conviction&rdquo; (&ldquo;The 1% Solution&rdquo;), starring Hayley Atwell, as well as an episode of the Showtime drama series &ldquo;Billions&rdquo; (&ldquo;YumTime&rdquo;), starring Paul Giamatti, Damian Lewis, Maggie Siff and Malin Akerman.</p>
<p>Hornbacher debuted as a stage director with a recent Los Angeles production of Neil LaBute&rsquo;s &ldquo;Reasons to Be Pretty,&rdquo; starring Wolfgang Novogratz, Laura Coover, Mercer Boffey and Andrea Hunt, which was produced in association with Aquila Morong Studio and Wolfgang Novogratz at The Lounge Theatre in Hollywood.</p>
<p>Hornbacher is developing the one-hour series drama &ldquo;Submission&rdquo; as well as two thematically linked 90- minute improv-to-film projects, <em>Open a Vein </em>and <em>Disillusion</em>.</p>

                        
                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section55" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>

<h2>IAN MCSHANE</h2>
<h3> (EXECUTIVE PRODUCER)</h3>
<p>Just before graduating from the prestigious Royal Academy of Dramatic Art, Ian McShane caught his first break in 1962 when he landed the lead role in <em>The Wild and the Willing</em>. Other earlier breakout roles include the role of Anthony in the 1973 cult classic <em>The Last of Sheila</em>, Wolfe Lissner in <em>Villain </em>and Charlie Cartwright in <em>If It&rsquo;s Tuesday, This Must Be Belgium</em>.</p>
<p>McShane gained critical acclaim on the small screen as the fierce yet charismatic Al Swearengen in<br>
  HBO&rsquo;s hit crime series &ldquo;Deadwood,&rdquo; for which he won a Golden Globe<sup>&reg;</sup> Award for Best Performance by an Actor in a Drama Series in 2005. His compelling and gritty portrayal also earned him nominations for an Emmy<sup>&reg;</sup> Award that same year and a SAG Award in 2006. In 2010, McShane went on to garner another Golden Globe<sup>&reg;</sup> nomination for Best Actor in a Miniseries for his portrayal of the scheming Waleran Bigod in Starz&rsquo;s Emmy<sup>&reg;</sup>-nominated &ldquo;The Pillars of the Earth.&rdquo;</p>
<p>Since then, McShane has been seen starring opposite Johnny Depp as the pirate Blackbeard in Disney&rsquo;s worldwide blockbuster hit <em>Pirates of the Caribbean: On Stranger Tides</em>. In 2015, he also appeared as the cold-blooded billionaire Andrew Finney opposite Liev Schreiber in Season 3 of the Showtime series &ldquo;Ray Donovan.&rdquo; McShane has had other notable roles on popular television series, including FX&rsquo;s &ldquo;American Horror Story&rdquo; and HBO&rsquo;s highly regarded and award-winning &ldquo;Game of Thrones.&rdquo; HBO announced a &ldquo;Deadwood&rdquo; movie in 2018, which McShane shot in the fall that same year. McShane reprises his role as club owner and ex-assassin Winston in the upcoming <em>John Wick: Chapter 3, </em>which will soon begin production. He can also be seen in projects such as <em>The Hollow Point</em>, <em>Jawbone </em>and <em>Pottersville</em>.</p>
<p>McShane is also an accomplished, award-winning stage actor who made his West End debut in 1967 when he co-starred with Dame Judi Dench and Sir Ian McKellen in &ldquo;The Promise.&rdquo; Other notable stage performances include his portrayal of Daryl Van Horne in &ldquo;The Witches of Eastwick&rdquo; and, most significantly, his role in the world premiere of Larry Atlas' &ldquo;Yield of the Long Bond,&rdquo; for which he received the 1984 Los Angeles Drama Critics Circle Award.</p>
<p>With a decorated career spanning more than five decades, McShane&rsquo;s other noteworthy roles on the big screen have included Joe Strombel in Woody Allen&rsquo;s <em>Scoop</em>; King Brahmwell in Bryan Singer&rsquo;s modern- day fairy tale <em>Jack the Giant Slayer</em>; and priest/prophet/warrior Amphiaraus, opposite Dwayne Johnson, in MGM's <em>Hercules </em>for director Brett Ratner. Notable roles on the small screen have included Sir Eric Russell in the landmark, blockbuster miniseries &ldquo;Roots&rdquo; and Ken Harrison in &ldquo;Whose Life is it Anyway?&rdquo; He also starred as the lovable rogue antiques dealer in the acclaimed series &ldquo;Lovejoy,&rdquo; which he also produced (and several episodes of which he directed) for the BBC and A&amp;E. The show, which first aired in 1986, was brought back by popular demand, successfully airing in both the U.S. and the U.K. from 1991 to 1994.</p>
<p>McShane also made his mark in film and television as a voiceover artist. He has lent his voice as the narrator of Disney&rsquo;s <em>The Sorcerer&rsquo;s Apprentice </em>and as the characters of Captain Hook in <em>Shrek the Third</em>, Tai Lung in <em>Kung Fu Panda </em>and Ragnar Sturlusson in <em>The Golden Compass</em>.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section56" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
               <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                       

<h2>STEFANIE BERK </h2>
<h3>(EXECUTIVE PRODUCER)</h3>
<p>Stefanie Berk is currently the executive vice president of television at FilmNation. Previously with FremantleMedia North America (FMNA) starting in 2013, Berk was engaged to build the U.S. scripted television division and brought &ldquo;American Gods&rdquo; to the company. With Berk serving as an executive producer, &ldquo;American Gods&rdquo; premiered to more than 5 million viewers and was the No. 1 launch on Starz in its inaugural season.</p>
<p>In addition to &ldquo;American Gods,&rdquo; Berk also served as one of FMNA&rsquo;s executive producers on the critically acclaimed &ldquo;The Returned&rdquo; on A&amp;E, an adaptation of the International Emmy<sup>&reg;</sup> Award–winning French series &ldquo;Les Revenants.&rdquo;</p>
<p>Berk joined FMNA from Playtone, where she was senior vice president and head of development. In these roles, she developed and managed all TV and film projects for company partners Tom Hanks and Gary Goetzman, including &ldquo;Big Love,&rdquo; <em>Where the Wild Things Are</em>, &ldquo;John Adams,&rdquo; and <em>Game Change</em>.<br>
  Prior to Playtone, Berk was an assistant to director Baz Luhrmann.</p>
<p>Berk is a graduate of both Columbia University, Graduate Film Division, where she received an M.F.A. in film writing/directing/producing and the University of California, Berkeley, where she received a B.A. in rhetoric/film theory.</p>



                        
                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section57" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>PADRAIC MCKINLEY </h2>
<h3>(EXECUTIVE PRODUCER)</h3>
<p>Padraic McKinley was born in San Francisco, California. He began his career in film as a music editor for renowned film editor William Anderson, A.C.E. After successful collaborations with Anderson, including Paramount Pictures&rsquo; <em>The Truman Show</em>, McKinley began editing music videos, commercials, documentaries and title sequences for The Picture Company in Dublin, Ireland.</p>
<p>McKinley has since cut 14 feature films and over 100 episodes of television.</p>
<p>Feature film credits include the 2002 critical standout <em>Igby Goes Down </em>(MGM), the 2004 remake of <em>Alfie </em>(Paramount Pictures), <em>17 Again </em>(New Line Cinema), <em>The Express </em>(Universal Pictures), <em>Pride and Prejudice </em><em>and Zombies </em>(Sony), and recently, Netflix&rsquo;s standout original, <em>Wheelman</em>.</p>
<p>Television credits include such notable shows as &ldquo;The Shield&rdquo; (FX), &ldquo;Dexter&rdquo; (Showtime) and the critically acclaimed drama &ldquo;Kingdom&rdquo; for DIRECTV&rsquo;s Audience Network.</p>
<p>McKinley directed four episodes of &ldquo;Kingdom,&rdquo; including the series finale, and served as co-executive producer, supervising editor, music editor, and co-music supervisor of the show.</p>
<p>Most recently, McKinley travelled the globe as the director, writer and editor of the upcoming Netflix documentary series &ldquo;Fightworld.&rdquo;</p>

                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section58" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>CHRISTOPHER J. BYRNE</h2>
<h3><strong>(EXECUTIVE PRODUCER, DIRECTOR EP 201 and 208)</strong></h3>
<p>Christopher J. Byrne&rsquo;s career in film and television, as well as commercial production, spans 20 years. His directing credits include CBS&rsquo; &ldquo;Star Trek: Discovery,&rdquo; and NBC&rsquo;s critically acclaimed &ldquo;Hannibal,&rdquo; for which he and showrunner Bryan Fuller developed the unique visual language, with an attention to detail that became the series&rsquo; signature look. Byrne served as second unit director and concept artist on NBC&rsquo;sbtime-travel series &ldquo;12 Monkeys,&rdquo; and he was tapped to direct an episode in Season 4. He joined</p>
<p>&ldquo;American Gods&rdquo; as the full-time second unit director in its first season, playing a large part in the development of the look of the show.</p>
<p>Byrne is a member of the Directors Guild of America and the Directors Guild of Canada, as well as the American Federation of Musicians as a composer. An avid musician, Byrne is a partner in the Toronto- based boutique music production company Bonspiel Music &amp; Publishing Company <em>(</em><u><a href="http://www.bonspiel.tv/">www.bonspiel.tv</a></u>)<em>.</em></p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section59" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>LISA KUSSNER</h2>
<h3>(PRODUCER)</h3>
<p>Lisa Kussner is an accomplished television producer and production manager with over 20 years of experience in scripted projects. In addition to this season of &quot;American Gods,&quot; Kussner's credits include NBC&rsquo;s Emmy<sup>&reg;</sup>-nominated &ldquo;Hannibal,&rdquo; which she produced, and Bravo's &quot;Imposters,&quot; which she co- produced. She has covered more than 75 scripted projects for Film Finances during her time working with the Bond Company. As production manager, her credits include Season 1 of &ldquo;American Gods&rdquo; and Syfy's &ldquo;Killjoys,&rdquo; among others.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section60" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>HEATHER BELLSON</h2>
<h3><strong>(CO-EXECUTIVE PRODUCER, WRITER EP 203 and 207)</strong></h3>
<p>Heather Bellson is a television writer and producer. She wrote for shows such as &ldquo;Black Sails,&rdquo; &ldquo;The Walking Dead&rdquo; and &ldquo;The Exorcist&rdquo; before joining &ldquo;American Gods.&rdquo; She grew up in Nashville and now lives in Los Angeles.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section61" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>RODNEY BARNES</h2>
<h3><strong>(CO-EXECUTIVE PRODUCER, WRITER EP 205)</strong></h3>
<p>Rodney Barnes is the award-winning writer/producer of &ldquo;Boondocks&rdquo; (Peabody, NAACP Image Awards), &ldquo;Everybody Hates Chris&rdquo; (AFI, NAACP Image Awards), Marvel&rsquo;s &ldquo;Runaways,&rdquo; the 88th annual Academy Awards<sup>&reg;</sup>, and a host of other television programs and feature films.</p>
<p>He has also authored graphic novels for Marvel Comics&rsquo; <em>The Falcon </em>and Marvel/Lucasfilm&rsquo;s <em>Lando: Double or Nothing</em>, based on the character Lando Calrissian from the Star Wars franchise. Currently, Barnes is writing and developing a number of feature films, television pilots and graphic novels.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section62" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>ADRIA LANG</h2>
<h3><strong>(SUPERVISING PRODUCER, WRITER 206)</strong></h3>
<p>Adria Lang began her television career as a participant of the Warner Bros. Television Writers&rsquo; Workshop. Her original spec script, &ldquo;Bound,&rdquo; written under program mentorship, was picked up for development by Warner Bros and Le Train Train Productions (Rashida Jones and Will McCormack)<br>
before she even graduated — a workshop first. Immediately after WBTWW, she staffed on ABC&rsquo;s &ldquo;666 Park Avenue,&rdquo; followed by work on FX&rsquo;s &ldquo;Sons of Anarchy,&rdquo; Syfy&rsquo;s &ldquo;Helix&rdquo; and USA&rsquo;s &ldquo;Satisfaction.&rdquo; Lang relocated to Berlin for several months to write and produce on &ldquo;Berlin Station&rdquo; for Epix. Last year, she worked on Season 1 of Greg Berlanti and Sera Gamble&rsquo;s romcom thriller, &ldquo;You,&rdquo; for Lifetime. Currently in the works is an adaptation of Pulitzer Prize–winning author Robert K. Massie&rsquo;s book <em>Catherine the Great: Portrait of a Woman </em>for ABC Signature. And she has very recently partnered with Blumhouse Television to further develop her original series &ldquo;Cascadia&rdquo; — a twisted soap opera that takes place before, during and after a natural disaster. She is married to an intimidatingly brilliant engineer. They live happily on a hill in Highland Park, Los Angeles.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section63" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>PETER CALLOWAY</h2>
<h3><strong>(CONSULTING PRODUCER, WRITER EP 204)</strong></h3>
<p>Peter Calloway is a television, movie and comic-book writer. He has served as a writer and producer on hundreds of hours of television — most recently, &ldquo;Legion&rdquo; and &ldquo;Cloak &amp; Dagger.&rdquo; A life-long comic book fan, he has written both his own comics on the indie side of the business as well as major titles for DC Comics, such as <em>Batman</em>, <em>Gotham City Sirens </em>and <em>Joker&rsquo;s Asylum</em>. Also, his wife thinks his grilled burgers are the best around.</p>




                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section64" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>ORLANDO JONES </h2>
<h3>(CONSULTING PRODUCER)</h3>
<p>In an unconventional career spanning 30 years, Orlando Jones is best known for his indelible performances on screen and stage. Dubbed the King of Fandom by MTV, he has also established himself as an influential force within the fandom universe.</p>
<p>Jones has always had a penchant for idiosyncratic projects. His recent work includes starring opposite Laurence Fishburne as the anti-apartheid revolutionary Oliver Tambo in &ldquo;Madiba&rdquo;<em>; </em>being tapped by the Duplass Brothers for their dark comedy &ldquo;Room 104&rdquo; on HBO; helping Syfy celebrate its 25th anniversary by legally marrying fans at the San Diego Comic Con (yes, Jones is ordained); partnering with Roberto Orci to launch Ubisoft&rsquo;s <em>Tom Clancy&rsquo;s Ghost Recon Wildlands: War Within the Cartel </em>franchise with a short film for Amazon and Twitch; filming a sold-out Comedy Central special in South Africa; and hosting and producing content for the digital broadcast of the 88th Academy Awards<sup>&reg;</sup>.</p>
<p>Jones has joined with Open Nest to advise progressive brands on the building of authentic, meaningful relationships with fans. This, coupled with his academic work in the burgeoning science of fan engagement, allows him to help realign brand focus to where it was always meant to be: on the fans.</p>





                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section65" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>ANDRES FISCHER-CENTENO</h2>
<h3><strong>(EXECUTIVE STORY EDITOR, WRITER EP 202)</strong></h3>
<p>Andres Fischer-Centeno is a writer based out of Los Angeles by way of Milwaukee, Wisconsin. He came to &ldquo;American Gods&rdquo; after writing on AMC&rsquo;s &ldquo;The Terror.&rdquo; Previously, he wrote for &ldquo;Under the Dome&rdquo; (CBS), and he also happens to be a two-time fantasy baseball champion.</p>

                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section66" class="section production">
            <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>ADITI BRENNAN KAPIL</h2>
<h3><strong>(WRITER EP 204, 208)</strong></h3>
<p>Aditi Brennan Kapil is a television and theater writer, actress and director. She is of Bulgarian and Indian descent, and she was raised in Sweden prior to moving to Minneapolis, and more recently, Los Angeles. Current projects include a new play titled &ldquo;1933&rdquo; commissioned by La Jolla Playhouse, two commissions (a translation of Shakespeare&rsquo;s &ldquo;Measure for Measure,&rdquo; and an American Revolution piece tentatively titled &ldquo;Pax Americana&rdquo;) with the Oregon Shakespeare Festival, and an as yet untitled commission with Audible. Most recently, in the 2016/2017 season, Brennan Kapil premiered SouthCoast Repertory (SCR)– commissioned play &ldquo;Orange&rdquo; at Mixed Blood Theatre and at SCR, and the Yale Rep–commissioned play &ldquo;Imogen Says Nothing&rdquo; at the Yale Repertory Theatre. She is a Resident Playwright at New Dramatists.</p>
<p>Brennan Kapil&rsquo;s first play, &ldquo;Love Person&rdquo; (a four-part love story in Sanskrit, ASL and English) was developed during a Many Voices residency at the Playwrights&rsquo; Center, workshopped at the Lark Play Development Center, and selected for reading at the National New Play Network (NNPN) conference in 2006. &ldquo;Love Person&rdquo; was produced in an NNPN rolling world premiere at Mixed Blood Theatre (MN), Marin Theater (CA) and Phoenix Theatre (IN) in the 2007/2008 season. In 2008/2009, it was produced at Live Girls! Theatre in Seattle, Alley Repertory Theatre in Boise, and Victory Gardens Theatre in Chicago. &ldquo;Love Person&rdquo; received the Stavis Playwright Award in 2009.</p>
<p>Her play &ldquo;Agnes Under The Big Top: A Tall Tale&rdquo; was selected as a 2009 Distinguished New Play Development Project by the NEA New Play Development Program hosted by Arena Stage. It was developed by the Lark Play Development Center (NYC), Mixed Blood Theatre (MN), InterAct Theatre Company (PA), the Playwrights&rsquo; Center (MN), and the Rhodope International Theatre Laboratory (Bulgaria). It premiered at Mixed Blood Theatre and Long Wharf Theatre (CT) in 2011, and at Borderlands Theater (AZ) in 2012 in an NNPN rolling world premiere.</p>
<p>Brennan Kapil&rsquo;s &ldquo;Displaced Hindu Gods Trilogy&rdquo; (&ldquo;Brahman/i,&rdquo; a one-hijra stand-up comedy show; &ldquo;The Chronicles of Kalki&rdquo;; and &ldquo;Shiv&rdquo;) — based loosely on the Hindu trinity of Brahma, Vishnu and Shiva — premiered in repertory at Mixed Blood Theatre in October 2013. The plays have since been produced across the U.S. and in the U.K. &ldquo;Brahman/&rdquo;&quot; and &ldquo;The Chronicles of Kalki&rdquo; received an unprecedented double nomination for the James Tait Black Prize, University of Edinburgh.</p>

                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section67" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>TYLER DINUCCI </h2>
<h3>(WRITER EP 202)</h3>
<p>Tyler Dinucci was the writers' assistant on Season1 of &ldquo;Star Trek: Discovery&rdquo; on CBS All Access, and he was executive assistant to Michael Green on Season 1 of &ldquo;American Gods.&rdquo; Before becoming a television writer, Dinucci worked in political fundraising, providing strategic analysis and assistance to consultants on a variety of national elections. Dinucci was born and raised in Connecticut. He has a B.A. in English and political science from Bucknell University.</p>

                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section68" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>TICO POULAKAKIS</h2>
<h3><strong>(DIRECTOR OF PHOTOGRAPHY)</strong></h3>
<p>In the past few years, Tico Poulakakis has gone from being one of the most in-demand commercial DPs to one of the most in-demand television DPs. His TV credits include Season 2 of the Warner Bros./Jerry Bruckheimer series &ldquo;Lucifer&rdquo; for Fox, Sky&rsquo;s series &ldquo;The Five,&rdquo; Syfy/Atlas&rsquo;s &ldquo;12 Monkeys&rdquo; and NBC&rsquo;s &ldquo;Hannibal&rdquo; (Second Unit). Poulakakis also lensed the feature films <em>I&rsquo;ll Follow You Down</em>, directed by Richie Mehta and <em>In Return </em>with Director Chris Dymond.</p>
<p>His commercial campaigns include prestigious brands such as Audi, FedEx, Volkswagen, Tropicana, Bombardier, McDonalds and Captain Morgan, to name a few.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section69" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>DAVID GREENE</h2>
<h3><strong>(DIRECTOR OF PHOTOGRAPHY)</strong></h3>
<p>Nominated for ASC, CSC, Genie, and Gemini Awards, David Greene has accumulated an impressive body of work in both film and television. Greene's feature credits include the critically acclaimed <em>Rhinoceros Eyes</em>, which won the Discovery Award at TIFF; <em>Tennessee </em>for Lee Daniels Entertainment; Peter Stebbings' <em>Empire of Dirt</em>; and <em>Defendor</em>, starring Woody Harrelson, which premiered to much acclaim at TIFF.</p>
<p>Greene also shot the MOW <em>The Trip to Bountiful</em>, which earned him an ASC nomination. On the<br>
  television side, Greene&rsquo;s work includes &ldquo;Platinum&rdquo; (UPN, co-created by John Ridley and Sofia Coppola), three seasons of &ldquo;Lost Girl&rdquo; (Showcase), &ldquo;Eyewitness&rdquo; (USA), and the miniseries &ldquo;XIII: The Series&rdquo; (Showcase). Greene has also shot all four seasons of &ldquo;12 Monkeys&rdquo; (Syfy), for which he has received an ASC nomination and two CSC wins.</p>
<p>Greene was also honored by the CSC with the Masters' Award in 2017. Most recently, he shot &ldquo;Impulse&rdquo; for YouTube Red.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section70" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2><strong>MARC LALIBERTÉ ELSE</strong></h2>
<h3><strong>(DIRECTOR OF PHOTOGRAPHY EP 208, SECOND UNIT DOP RUN OF SEASON)</strong></h3>
<p>Marc Laliberté Else&rsquo;s work is both cinematic and real. He gravitates towards a naturalistic aesthetic,<br>
aligning his projects to the director&rsquo;s vision. In addition to &ldquo;American Gods,&rdquo; his television credits include the Hulu dark comedy series &ldquo;Farmed &amp; Dangerous,&rdquo; and second unit work on the series &ldquo;12 Monkeys.&rdquo; Other credits include two cable features for MTV and a TV pilot for UPN.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section71" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>RORY CHEYNE </h2>
<h3>(PRODUCTION DESIGNER)</h3>
<p>Rory Cheyne is a Toronto-based television, feature film, and commercial production designer. In<br>
  addition to his work on &ldquo;American Gods&rdquo; for Starz, Cheyne&rsquo;s credits include the third season of Bryan Fuller&rsquo;s hit series &ldquo;Hannibal&rdquo; and back-to-back seasons of the Canadian award-winning series &ldquo;Cardinal&rdquo; for CTV and Hulu.</p>
<p>Cheyne&rsquo;s work also extends beyond the entertainment industry. In 2002, he played a key role in the concept design for multiple stages, as well as in the overall creative look, of World Youth Day. The event hosted over 1 million people, including the late Pope John Paul II, whom Cheyne had the honor of
meeting. He was also a design team lead, creating and executing trade show exhibits for the Toronto Green Living Trade Show. Additionally, Cheyne was asked to collaborate with architect Anne-Rachel Schiffmann on various industrial design projects throughout New York City in 2004.</p>
<p>A graduate of the prestigious Ontario College of Art and Design (now OCAD), Cheyne was a recipient of the Ontario Association of Architects Award.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>



          <div id="section72" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>DEBRA ZANE </h2>
<h3>(CASTING DIRECTOR)</h3>
<p>Debra Zane is an award-winning casting director known for her work in film and television. She has worked with some of the most successful directors in the business — most notably, Steven Spielberg, Sam Mendes, Ridley Scott, Steven Soderbergh, Bill Condon and Gary Ross.</p>
<p>She is the casting director of <em>The Hunger Games </em>franchise, the reboot of <em>The Planet of the Apes </em>franchise and the Walt Disney Studios upcoming live-action <em>Mulan</em>.</p>
<p>In 2015, Zane was awarded an Artios Award from the Casting Society of America for Outstanding Achievement in Casting – Television Series Drama for Sony/Netflix's &quot;Bloodline.&quot;</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section73" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>JASON KNIGHT</h2>
<h3><strong>(CASTING DIRECTOR - CANADA)</strong></h3>
<p>Jason Knight is a Toronto-based casting director. Some recent credits include Christoph Waltz's <em>Georgetown</em>, Andrew Niccol's <em>Anon</em>, Tom McCarthy's <em>Spotlight </em>(CSA nomination), Atom Egoyan's <em>Remember</em>, DC Comics' &ldquo;Titans&rdquo; for Greg Berlanti, and both seasons of series &ldquo;The Girlfriend Experience,&rdquo; exec-produced by Steven Soderbergh. Knight and his partner, John Buchan, won the 2010 Gemini Award for Best Achievement in Casting. Knight is a casting director in residence and a mentor for the Canadian Film Centre&rsquo;s Actors Conservatory. He also currently serves as the casting consultant for CBC Television, where he and Buchan oversee all casting for scripted programming at the network.</p>

                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section74" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>CLAIRE ANDERSON</h2>
<h3><strong>(COSTUME DESIGNER EP 201–204)</strong></h3>
<p>Costume designer Claire Anderson&rsquo;s designs have been featured in some of Britain&rsquo;s best-known film and television productions, including the BAFTA-nominated &ldquo;Black Mirror&rdquo; (&ldquo;Hang the DJ&rdquo;), &ldquo;The<br>
Witness for the Prosecution&rdquo; and &ldquo;Life in Squares.&rdquo;</p>
<p>Following a B.A. (Honors) in fashion textiles, Anderson completed a post-graduate degree at Central St. Martins in London, England, before launching her career in film and television with the independent coming-of-age film <em>Human Traffic, </em>written and directed by Justin Kerrigan. Additional film credits include <em>A Royal Night Out, The Limehouse Golem </em>and <em>City of Tiny Lights.</em></p>
<p>During a career that spans over 20 years on stage and on screen, featuring a range of genres and periods, Anderson has worked with award-winning talent such as Emily Watson, Michael Sheen, Chloë Sevigny, Rupert Everett, Kim Cattrall, Sarah Gadon and David Tennant.</p>
<p>She recently completed production on Neil Gaiman and Terry Pratchett&rsquo;s upcoming &ldquo;Good Omens&rdquo; for BBC and Amazon.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section75" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>ROBERT BLACKMAN</h2>
<h3><strong>(COSTUME DESIGNER EP 205–208)</strong></h3>
<p>Robert Blackman is a multiple Emmy<sup>&reg;</sup> Award–winning costume designer, best known for his work on the &ldquo;Star Trek&rdquo; franchise. A graduate of the Yale School of Drama, Blackman has also designed for such TV shows as &ldquo;Pushing Daisies,&rdquo; &ldquo;Rizzoli &amp; Isles,&rdquo; &ldquo;GCB,&rdquo; &ldquo;Glee,&rdquo; &ldquo;Extant&rdquo; and &ldquo;Life Sentence.&rdquo; He most recently wrapped Season 2 of FX's critically acclaimed &ldquo;Legion.&rdquo; Blackman lives in Palm Springs with his husband Mark and their three dogs.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section76" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>COLIN PENMAN</h2>
<h3><strong>(HEAD OF MAKEUP DEPARTMENT)</strong></h3>
<p>Colin Penman is an Emmy<sup>&reg;</sup>-winning makeup artist with 30 years of experience in film and television. He began focusing primarily on prosthetic and special makeup effects, but he soon broadened his skills to encompass all aspects of makeup artistry.</p>
<p>Other notable credits include &ldquo;Star Trek: Discovery,&rdquo; the Stephen King miniseries &ldquo;11.22.63,&rdquo; Guillermo del Toro&rsquo;s &ldquo;The Strain&rdquo; and <em>Pacific Rim</em>, as well as the series &ldquo;Total Recall,&rdquo; &ldquo;The Kennedys,&rdquo; &ldquo;Defiance,&rdquo; &ldquo;Copper,&rdquo; and the feature film <em>Hairspray</em>.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section77" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>DANIEL CURET</h2>
<h3><strong>(HEAD OF HAIR DEPARTMENT)</strong></h3>
<p>Daniel Curet is a true master of the art of hair. Receiving two coveted Emmy<sup>&reg;</sup> nominations for the whimsical and eclectic &ldquo;Pushing Daisies,&rdquo; Curet is among the top in his field, respected for his dedication and admired for his artistry. With over 60 film and televis ion projects to his name, Curet's illustrious career began with character-driven cult hits <em>Fargo </em>and <em>The Big Lebowski </em>— a trend he continues to pursue in his career. It is his ability to tell a story through hairstyles and his ongoing partnerships with the actors on screen to ensure that their true vison of the character is brought to life that has given Curet his acclaimed status in the industry. From styling and application to extensive corrective color and wig work, Daniel's work has brought life to many incredible characters, both in film and on television. Most recently, Curet's vision and work helped create the magical worlds of &ldquo;The Vampire Diaries,&rdquo; &ldquo;Salem,&rdquo; &ldquo;Sleepy Hollow,&rdquo; and &ldquo;Westworld.&rdquo;</p>
<p>He has worked with a roster of Hollywood directors and producers that includes Joel and Ethan Coen, Kenny Ortega, Marc Webb, and more. Curet's Hollywood talent collaborations include Jennifer Aniston, Harrison Ford, Emily Blunt and Alec Baldwin. When not on set, Curet is busy teaching and continuing his entrepreneurial endeavors.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section78" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>LAYTON MORRISON</h2>
<h3>(STUNT COORDINATOR)</h3>
<p>Stunt coordinator Layton Morrison has over 30 years of experience in the film industry, working on over 200 productions. Most recently, he served as stunt coordinator on <em>xXx: Return of Xander Cage</em>, starring Vin Diesel; the DC Extended Universe's third installment, <em>Suicide Squad, </em>featuring Will Smith; <em>Pixels, </em>the feature-length adaptation of Patrick Jean's video-game-themed short; the political action thriller <em>White House Down</em>, directed by Rolland Emmerich; and <em>Godzilla </em>for Warner Bros.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section79" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>ERIC ROBERTSON</h2>
<h3><strong>(SENIOR VISUAL EFFECTS SUPERVISOR)</strong></h3>
<p>Eric J. Robertson, managing director of Mr. X&rsquo;s New York and Los Angeles VFX studios, has supervised and produced visual effects for 100 feature films and series throughout his career, working with some of film&rsquo;s most respected directors: Ang Lee, Ron Howard, Jonathan Demme, Sam Mendes, Doug Liman, Joel and Ethan Coen, Jim Jarmusch and Charlie Kaufman.</p>
<p>In addition to his work as a VFX supervisor, Robertson is also an accomplished photographer and cinematographer, whose 20+ years of experience in production have given him a storyteller&rsquo;s eye and a technical prowess that encompass all aspects of the filmmaking process — from script to screen — and that span a multitude of genres. Seamlessly integrating the storyteller&rsquo;s vision with visual effects, his creations go from exhilarating and hilarious to emotional and engaging.</p>
<p>Robertson was instrumental in expanding the Visual Effects Society into New York City. He served as co- chairperson of the NYC section and is a Cinematographer member of IATSE Local 600.</p>
<p>His recent supervisor credits include <em>Zoolander 2</em>, Ang Lee&rsquo;s war-drama <em>Billy Lynn&rsquo;s Long Halftime Walk</em>, the Sundance hit <em>Mudbound</em>, and <em>American Made </em>with Tom Cruise.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section80" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>FREDERICK E.O. TOYE </h2>
<h3>(DIRECTOR EP 202)</h3>
<p>Frederick E.O. Toye made the move to television directing after working for five years as a production assistant and for a decade as an editor. Los Angeles–native Toye got his first screen credit working as a production assistant on Billy Crystal's 1989 HBO special <em>Midnight Train to Moscow</em>, before moving into visual effects on films such as <em>The Addams Family </em>(1991) and <em>Addams Family Values </em>(1993). He was assistant editor on hit films such as <em>Forrest Gump </em>(1994), and title designer on <em>Men in Black </em>(1996) <em>Courage Under Fire </em>(1997) and <em>The Siege </em>(1998), among others. After joining J.J. Abrams' spy fantasy &quot;Alias&quot; (ABC, 2001–2006) as editor, Toye started directing in Season 4, becoming a co-producer the same year. Since then, Toye has worked as a director on popular series, including &ldquo;CSI: NY,&rdquo; &quot;Ghost Whisperer,&quot; &quot;Chuck,&quot; &quot;Hawaii Five-0,&quot; &quot;Falling Skies,&quot; &ldquo;Lost,&quot; &quot;Person of Interest,&quot; &quot;The Good Wife&quot; and Hulu's &ldquo;11.22.63&quot; with James Franco. His connection with Abrams led to producing and directing roles on another one of the prolific producer's TV projects, the science-fiction drama &quot;Fringe.&rdquo; Toye became co-executive producer/director on the first season of ABC's &quot;Designated Survivor.&rdquo; He has continued in the same role on Season 2 of HBO&rsquo;s &ldquo;Westworld.&rdquo;</p>




                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section81" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>DEBORAH CHOW </h2>
<h3>(DIRECTOR EP 203)</h3>
<p>Deborah Chow received her M.F.A in directing from Columbia University. She wrote and directed <em>The </em><em>High Cost of Living, </em>which won the Best First Feature award during its world premiere at the Toronto International Film Festival and was released theatrically by Tribeca Films. She has also worked extensively in television and has directed on numerous shows including &ldquo;Mr. Robot,&rdquo; &ldquo;Jessica Jones&rdquo; and &ldquo;Better Call Saul.&rdquo;</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section82" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>STACIE PASSON </h2>
<h3>(DIRECTOR EP 204)</h3>
<p>Stacie Passon is an American director, writer and producer whose debut film, <em>Concussion</em>, premiered at the 2013 Sundance Film Festival and subsequently won a Teddy Award Jury Prize at the 2013 Berlin International Film Festival. Passon also received a Film Independent Spirit Award nomination for Best First Feature in 2014 as well as a Gotham Award nomination for Breakthrough Director.</p>
<p>In television, Passon has directed multiple episodes of the Primetime Emmy<sup>&reg;</sup> Award–winning series &ldquo;Transparent&rdquo; and &ldquo;The Path&rdquo; for Hulu, as well as episodes of the F. Scott Fitzgerald–adapted drama series &ldquo;The Last Tycoon&rdquo; for Amazon and &ldquo;Halt and Catch Fire&rdquo; for AMC. In 2018, she directed episodes of &ldquo;The Affair&rdquo; and &ldquo;Billions&rdquo; for Showtime, &ldquo;House of Cards&rdquo; for Netflix, and &ldquo;Punisher&rdquo; for Marvel/Netflix.</p>
<p>Passon&rsquo;s sophomore feature, <em>We Have Always Lived in the Castle, </em>is an adaptation of Shirley Jackson&rsquo;s acclaimed novel. The film stars Sebastian Stan, Taissa Farmiga, Alexandra Daddario and Crispin Glover.</p>



                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section83" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>SALLI RICHARDSON-WHITFIELD </h2>
<h3>(DIRECTOR EP 205)</h3>
<p>Salli Richardson-Whitfield is an industry veteran of over 30 years. She is featured in over 20 major motion pictures and has starred opposite a number of Hollywood&rsquo;s top actors, including Samuel L. Jackson in <em>The Great White Hype</em>, Denzel Washington in <em>Antwone Fisher</em>, and Will Smith in <em>I Am Legend</em>. She is best known for starring in the Syfy hit series &ldquo;Eureka,&rdquo; for which she also directed two episodes.</p>
<p>After starting her directing career on &ldquo;Eureka,&rdquo; she directed a block of episodes for the new Ava DuVernay OWN series, &ldquo;Queen Sugar&rdquo; an episode of &ldquo;Shadowhunters: The Mortal Instruments&rdquo; for Freeform; and an episode of &ldquo;Underground&rdquo; for WGN. In 2017, she wrapped on her episodes of Starz's &ldquo;Survivor&rsquo;s Remorse&rdquo; and ABC's &ldquo;Scandal.&rdquo; She has directed Netflix&rsquo;s &ldquo;Luke Cage,&rdquo; Syfy&rsquo;s &ldquo;The Magicians,&rdquo; Fox&rsquo;s &ldquo;Star&rdquo; and an episode of Freeform&rsquo;s &ldquo;Stitchers,&rdquo; where she&rsquo;ll also return to her starring role for the third season</p>
<p>In her spare time, Salli Richardson-Whitfield is a wife and mother who participates in countless charitable and philanthropic events, including The K.I.S. Foundation.</p>




                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>

          <div id="section84" class="section production">                 <a  href="#bio1" class="prodNav">Back to Top</a>
              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>RACHEL TALALAY </h2>
<h3>(DIRECTOR EP 206)</h3>
<p>Rachel Talalay&rsquo;s eclectic resume includes directing &ldquo;Sherlock&rdquo;; seven episodes of &ldquo;Doctor Who&rdquo;; <em>Tank Girl</em>; <em>Freddy&rsquo;s Dead: The Final Nightmare</em>; &ldquo;Wind in the Willows&rdquo;; a number of award-winning miniseries (&ldquo;Terminal City,&rdquo; &ldquo;Durham County&rdquo; and &ldquo;Dice&rdquo;); and more than 75 hours of television in the U.S., the U.K. and Canada, such as &ldquo;Ally McBeal,&rdquo; &ldquo;Without a Trace,&rdquo; &ldquo;Randall &amp; Hopkirk (Deceased),&rdquo; &ldquo;Touching Evil,&rdquo; &ldquo;Riverdale&rdquo; and upcoming episodes for MarvelTV/Netflix&rsquo;s &ldquo;Chilling Adventures of Sabrina.&rdquo;</p>
<p>In between &ldquo;Doctor Who&rdquo; episodes, she directed the film based on Stevie Cameron&rsquo;s award-winning novel <em>On the Farm</em>, which examines the crimes of Robert Pickton and the stories of the women who battled to be heard. The film played numerous festivals, including Dallas, Portland, Vancouver, San Francisco, Los Angeles, Seattle, Missouri and Yellowknife. It won Best Narrative Feature at the Seattle Social Justice Film Festival as well as Best Filmmaking at LA Skins Festival, along with both a Canadian Screen Award and a Leo Award.</p>
<p>Talalay directed all of Peter Capaldi&rsquo;s &ldquo;Doctor Who&rdquo; two-part finales and two Hugo-nominated episodes, the 2017 Christmas Special &ldquo;Twice Upon a Time&rdquo; and the acclaimed experimental one-hander &ldquo;Heaven Sent.&rdquo; In 2016, Talalay also directed of the opening episode of Season 4 of the acclaimed series &ldquo;Sherlock&rdquo; (&ldquo;The Six Thatchers&rdquo;), starring Benedict Cumberbatch and Martin Freeman.</p>
<p>Her producing history is equally varied, ranging from <em>Hairspray </em>(the original) and <em>Cry-Baby </em>to the <em>A Nightmare on Elm Street </em>franchise (Parts 3 and 4) and <em>The Borrowers</em>.</p>
<p>She has been nominated for (and, on rare occasions, won) numerous awards, including the BAFTAs, Royal Television Society, Independent Spirit Awards, West Coast Emmys, Hugo Awards, the Geminis and Sitges. She was WIFTV&rsquo;s Spotlight Woman of the Year for 2016 and winner of both WIFT&rsquo;s Producer Award and the 2018 Inspiration Award for the Etheria Festival, presented by Lori Petty and John Waters.</p>
<p>Talalay is an active advocate for Gender Equity in the Film Business, including the social media campaign #AskForMore and #DiverseVoicesMatter.</p>


                      </b-col>
                  </b-row>
              </b-container>
              </div>
              <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" />
          </div>


          <div id="section85" class="section production">  
                <a  href="#bio1" class="prodNav">Back to Top</a>

              <div class="productionBios">
              <b-container>
                  <b-row>
                      <b-col>
                        
<h2>PACO CABEZAS </h2>
<h3>(DIRECTOR EP 207)</h3>
<p>Director Paco Cabezas began his career in a video store in his native Spain, where he would write the screenplays for his films. Critics first took note of his work with the feature film <em>Neon Flesh</em>, which debuted at the TriBeCa Film Festival in 2010. Soon after, Cabezas began working in Hollywood, where he shot <em>Mr. Right</em>. In 2015, the film was chosen as the closing night film at TIFF, where it premiered. His television credits include the season finale of &ldquo;Penny Dreadful&rdquo; as well as &ldquo;Fear the Walking Dead,&rdquo; &ldquo;The Alienist&rdquo; and &ldquo;Into the Badlands.&rdquo;</p>



                      </b-col>
                  </b-row>
              </b-container>

               </div>
                                          <!-- <b-img src="../../static/svg/Scrollicon.svg" class="downIcon" /> -->

          </div> 




      </full-page>
  </div>
</template>

<script>

export default {
  name: 'Production',
  metaInfo: {
    title: 'Production' // set a title
  },
  data () {
    return {
      options: {
        licenseKey: '08F6AFDB-F75D4F5A-AE124C87-3D28719F',
        menu: '#menu',
        anchors: ['loading', 'bio1', 'bio2', 'bio3', 'bio4', 'bio5', 'bio6', 'bio7', 'bio8', 'bio9', 'bio10', 'bio11', 'bio12', 'bio13', 'bio14', 'bio15', 'bio16', 'bio17', 'bio18', 'bio19', 'bio20', 'bio21', 'bio22', 'bio23', 'bio24', 'bio25', 'bio26', 'bio27', 'bio28', 'bio29', 'bio30', 'bio31', 'bio32', 'bio33', 'bio34', 'bio35', 'bio36'],
        slidesNavigation: true,
        controlArrows: true,
        scrollOverflow: true,
        lazyLoading: false,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad
      }
    }
  },
  methods: {
    afterLoad (origin, destination, direction) {
      if (destination.index === 0) {
        this.$refs.fullpageHome.api.moveSectionDown()
      }
    },
    onLeave (origin, destination, direction) {
      if (destination.index === 0) {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
      if (origin.index === 1 && destination === 'up') {
        document.getElementById('stzHeaderTitleArt').classList.add('titleArt-Hidden')
        document.getElementById('stzHeaderTitleArt').classList.remove('logo')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/Production.scss";
</style>



// WEBPACK FOOTER //
// src/components/Production.vue